import React from 'react';
import { connect } from 'react-redux';
import { LoadingSpinner } from '../components/LoadingSpinner/LoadingSpinner.component';
import { compose } from '../actions';
import { loadCityRumors } from '../actions/cityRumors.actions';

import "./stylings/CityRumors.css";
import { SingleCityRumor } from '../components/CityRumors/SingleCityRumor';
import SectionTitle from '../components/SectionTitle';

class CityRumors extends React.Component {
	componentDidMount() {
		if (this.props.dataIsLoading) {
			this.props.loadCityRumors();
		}
	}

	renderCityRumorElements() {
		return this.props.cityRumors.map((element, index) => {
			return <SingleCityRumor data={element} key={index} />;
		});
	}

	render() {
		if (this.props.dataIsLoading) {
			return <LoadingSpinner/>;
		}

		const rumors = this.renderCityRumorElements();
		console.log(this.props);

		return (
			<section className="city-rumors__section animated fadeIn">
				<div className="container">
					<SectionTitle title="Stadtgeflüster"/>
					<ul className="row">
						{rumors}
					</ul>
				</div>
			</section>
		);
	}
}

const mapStateToProps = ({cityRumors}) => {
	return {
		dataIsLoading: cityRumors.get('dataIsLoading'),
		cityRumors: cityRumors.get('cityRumors')
	};
};

const mapDispatchToProps = dispatch => {
	return {
		loadCityRumors: compose(dispatch, loadCityRumors)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CityRumors);


// WEBPACK FOOTER //
// ./src/containers/CityRumors.js